import React from "react";
import { Button, CircularProgress, TextField } from "@mui/material";
import { Image } from "mui-image";
import { apiCall, preloadImage } from "../../../utils/helpers";

export default function Interests({
  selectedSubTypes = [],
  setSelectedSubTypes = () => {},
  step = 1,
  setStep = () => {},
  verifying = false,
  setVerifying = () => {},
  onBoardingUser = {},
  updateCustomerHandler = () => {},
}) {
  const [categories, setCategories] = React.useState([]);

  const [otherExpertise, setOtherExpertise] = React.useState("");
  const [otherSelected, setOtherSelected] = React.useState(false);
  const [error, setError] = React.useState({ otherExpertise: false });

  const bottomRef = React.useRef(null);

  const getInterestsList = () => {
    apiCall
      .post("v1/user/getCategoryList", {
        admin_type_id: 1,
        // key: "JWT",
        // secret: "DOPAMINE",
        auth: onBoardingUser?.token,
        api_name: "getCategoryList",
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          res.data.data.forEach((category) => {
            preloadImage(category.inactive_icon);
            preloadImage(category.active_icon);
            return category;
          });
          setCategories(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  React.useEffect(() => {
    selectedSubTypes.forEach((st) => {
      if (
        st.category_id === 11 ||
        st.category_id === 27 ||
        st.category_id === 28
      ) {
        setOtherSelected(true);
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        setOtherSelected(false);
      }
    });
  }, [selectedSubTypes]);

  React.useEffect(() => {
    getInterestsList();
  }, []);

  return (
    <>
      <div
        className="onboarding-step onboarding-step-4"
        style={{ padding: "1rem" }}
      >
        <p
          style={{
            margin: "20px 0 40px 0",
            fontSize: "26px",
            fontWeight: 700,
            textAlign: "center",
            color: "#cfcfcf",
          }}
        >
          Select your interests
        </p>
        <div className="request-sub-types">
          {categories.map((category, index) => {
            const selectedCategory = selectedSubTypes.some(
              (selected) => category.category_id === selected.category_id
            );
            return (
              <div
                style={{
                  padding: "1px",
                  background:
                    "linear-gradient(152.68deg, #FFFFFF 5.46%, rgba(255, 255, 255, 0) 32.84%, rgba(255, 255, 255, 0) 71.3%, #FFFFFF 100%)",
                  marginRight: "2%",

                  marginBottom: "1rem",
                  borderRadius: 12,
                  width: "30%",
                  height: "120px",
                }}
              >
                <div
                  onClick={() => {
                    selectedCategory
                      ? setSelectedSubTypes(
                          selectedSubTypes.filter(
                            (selected) =>
                              selected.category_id !== category.category_id
                          )
                        )
                      : setSelectedSubTypes([...selectedSubTypes, category]);
                  }}
                  className={`request-sub-type ${
                    selectedCategory ? "selected-sub-type" : ""
                  }`}
                  // style={{ marginRight: (index + 1) % 3 === 0 && 0 }}
                  key={index}
                >
                  <div className="request-sub-type-icon">
                    <Image
                      height="100%"
                      width="100%"
                      fit="contain"
                      duration={800}
                      src={
                        selectedCategory
                          ? category.inactive_icon
                          : category.active_icon
                      }
                      alt=""
                    />
                  </div>
                  <span
                    style={{
                      color: selectedCategory ? "#222831" : "#fff",

                      fontWeight: "500",
                      fontSize: "0.75em",
                      paddingTop: "0.5rem",
                      textTransform: "capitalize",
                    }}
                  >
                    {category.category_name}
                  </span>
                </div>
              </div>
            );
          })}
          <div>
            {selectedSubTypes.forEach((type, index) => {
              if (
                type.category_id === 11 ||
                type.category_id === 27 ||
                type.category_id === 28
              ) {
                return (
                  <div
                    style={{ marginTop: "16px" }}
                    ref={bottomRef}
                    className="other-expertise"
                  >
                    <span style={{ fontSize: "1.2em", color: "#bdbfc1" }}>
                      Please enter other expertise
                    </span>
                    <TextField
                      label="Other expertise"
                      className="other-expertise"
                      value={otherExpertise}
                      onChange={(e) => {
                        setError({
                          ...error,
                          otherExpertise: e.target.value ? false : true,
                        });
                        setOtherExpertise(e.target.value);
                      }}
                      error={error.otherExpertise}
                      helperText={
                        error.otherExpertise
                          ? "Please enter other expertise"
                          : " "
                      }
                      style={{ margin: "0.5rem 0rem" }}
                      placeholder="Ex. expertise"
                      fullWidth
                      focused
                    />
                  </div>
                );
              }
            })}
          </div>
          {!categories.length && (
            <div style={{ margin: "2rem auto", minHeight: "60vh" }}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
      <div className="request-footer-btn">
        <Button
          onClick={() => updateCustomerHandler()}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",
            background:
              verifying ||
              !selectedSubTypes.length ||
              (otherExpertise === "" && otherSelected)
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color:
              verifying ||
              !selectedSubTypes.length ||
              (otherExpertise === "" && otherSelected)
                ? "#232323"
                : "#FF4A01",
          }}
          // style={{ padding: "16px 0", fontSize: "1em" }}
          disabled={
            verifying ||
            !selectedSubTypes.length ||
            (otherExpertise === "" && otherSelected)
          }
        >
          {verifying ? "Submitting..." : "Continue"}
        </Button>
      </div>
    </>
  );
}
